import { render, staticRenderFns } from "./ChipExternal.vue?vue&type=template&id=fb0d8bae"
import script from "./ChipExternal.vue?vue&type=script&lang=js"
export * from "./ChipExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports